// « retry » : réseau, délai, 5xx, 409 « en cours », import en cours ; « fatal » : refus de l'API (droits, quota, donnée invalide).
// L'API renvoie aussi 401 pour un manque de droits : seul « Project is importing data » est temporaire
export const classifyError = (error) => {
    const response = error?.response;
    if (!response) return { kind: 'retry', reason: error?.code === 'ECONNABORTED' ? 'timeout' : 'network', message: error?.message || '' };
    const { status, data } = response;
    const message = typeof data === 'string' ? data : (data?.title || data?.message || '');
    if (status >= 500 || [408, 409, 425, 429].includes(status)) return { kind: 'retry', reason: `http_${status}`, status, message };
    if (message === 'Project is importing data') return { kind: 'retry', reason: 'project_importing', status, message };
    return { kind: 'fatal', reason: `http_${status}`, status, message };
};
